// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a7bd1fec","256":"56fbb699","423":"4ebd0d68","453":"b0bb0a5e","580":"2f7b2ca0","716":"3994a47d"}[chunkId] + ".chunk.js";
};